export default __webpack_public_path__ + "static/media/taai.4bef762a.svg";